/**
 * Why an incoming **Rückmeldung** was not matched to a Lieferung
 * (TM-9636 / #1624).
 *
 * ⚠ **A Ruf 1 is never guessed** (#1572, decision 2). Every one of these
 * reasons ends with the raw mail being left lying and a human looking at it —
 * the queue and its handling are #1630. The alternative would be to hang an
 * Annahmebestätigung on the most likely Lieferung; with a Dateiablehnung that
 * would mean notifying the wrong practice about an incident it does not have.
 *
 * ⚠ **None of this is a fault of the Absender.** A Rückmeldung that lands here
 * is kept and complete nonetheless; what is missing is only the matching.
 */
export var UnmatchedRueckmeldungReason;
(function (UnmatchedRueckmeldungReason) {
    /**
     * The mail is neither a delivery notice nor a Ruf 1 nor a Ruf 2.
     *
     * ⚠ **Since #1625 that means: its subject does not carry the structure from
     * A7 §3.2.2.1.** A mail that does carry it is a Rückmeldung from the
     * Datenannahmestelle and hangs on its Versandversuch — as a Ruf 1 if one of
     * the two Verarbeitungskennzeichen stands at the front, otherwise as a
     * Verarbeitungsmeldung. What lands here is what does not come from the
     * procedure at all: a bounce without DSN structure, a misdirection, an
     * advertising mail to the dispatch mailbox.
     */
    UnmatchedRueckmeldungReason["UNREADABLE"] = "UNREADABLE";
    /**
     * The subject was readable, but there is no Versandversuch for
     * `(recipient, Transfernummer)`.
     */
    UnmatchedRueckmeldungReason["NO_ATTEMPT"] = "NO_ATTEMPT";
    /**
     * There are several equally recent attempts for `(recipient, Transfernummer)`.
     *
     * ⚠ **The Transfernummer wraps from 999 back to 000.** A second attempt with
     * the same number is therefore normal, and the **most recent** one wins; only
     * when two carry the same moment is there no reason left to prefer one over
     * the other.
     */
    UnmatchedRueckmeldungReason["MULTIPLE_ATTEMPTS"] = "MULTIPLE_ATTEMPTS";
})(UnmatchedRueckmeldungReason || (UnmatchedRueckmeldungReason = {}));
//# sourceMappingURL=unmatched-rueckmeldung-reason.enum.js.map